import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
interface PricingCard {
  title: string;
  pricePerUnit?: string;
  features: string[];
  price: string;
  highlighted?: boolean;
}
const memberships: PricingCard[] = [{
  title: 'FLEX-4',
  pricePerUnit: '13,75€/Einheit',
  features: ['4 einzigartige Einheiten im Monat', 'wähle frei aus allen verfügbaren Kursen', 'Mindestlaufzeit 3 Monate', 'danach Monatlich Kündbar'],
  price: '55,-€'
}, {
  title: 'FLEX-8',
  pricePerUnit: '11,15€/Einheit',
  features: ['8 unvergessliche Einheiten', 'freie Auswahl an Kursen', 'Mindestlaufzeit 3 Monate', 'danach monatlich kündbar'],
  price: '89,-€'
}, {
  title: 'FLEX-NO-LIMIT',
  features: ['genieße unbegrenzten Zugang zu allen unseren Kursen', 'keine Mindestlaufzeit', 'Monatlich kündbar', 'Trainingsplan für dein Ziel'],
  price: '139,-€',
  highlighted: true
}, {
  title: '10er Karte',
  pricePerUnit: '15,90€/Einheit',
  features: ['5 Monate gültig', 'keine Vertragsbindung', 'alle Kurse inkl.'],
  price: '159,-€'
}];
const singles: PricingCard[] = [{
  title: 'Drop-In',
  features: ['1x Trainieren', 'jeder Kurs wählbar', 'Voranmeldung erforderlich'],
  price: '20,-€'
}, {
  title: 'Probetraining',
  features: ['3x Testen', 'Jeder Kurs wählbar', '2 Wochen gültig'],
  price: '29,-€'
}, {
  title: 'PT',
  features: ['wenn du individuelle Betreuung zu schätzen weißt'],
  price: 'ab 65,-€'
}, {
  title: 'Wertgutschein',
  features: ['wenn du deinen liebsten das einzigartige Training schenken möchtest'],
  price: 'auswählen'
}];
function Card({
  card,
  delay
}: {
  card: PricingCard;
  delay: number;
}) {
  return <div className={`relative bg-white rounded-2xl p-8 flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-1 hover:shadow-xl animate-fade-in-up ${card.highlighted ? 'border-2 border-peony-500 shadow-[0_0_30px_rgba(232,114,138,0.2)]' : 'border border-peony-300'}`} style={{
    animationDelay: `${delay}ms`
  }} data-id="element-188">
      {card.highlighted && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-peony-500 text-white text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-189">
          Beliebt
        </span>}

      <h3 className="text-xl font-bold text-dark-studio mb-2" data-id="element-190">{card.title}</h3>

      {card.pricePerUnit && <p className="text-sm italic text-gray-500 mb-4" data-id="element-191">{card.pricePerUnit}</p>}

      <ul className="flex-1 space-y-2 mb-8 mt-2" data-id="element-192">
        {card.features.map((f, i) => <li key={i} className="text-gray-600 text-sm leading-relaxed" data-id="element-193">
            {f}
          </li>)}
      </ul>

      <button className={`px-8 py-3 rounded-full font-bold text-base transition-all duration-300 ${card.highlighted ? 'bg-peony-500 text-white hover:bg-peony-600 shadow-[0_0_15px_rgba(232,114,138,0.4)]' : 'border-2 border-peony-400 text-peony-600 hover:bg-peony-50'}`} data-id="element-194">
        {card.price}
      </button>
    </div>;
}
export function Pricing() {
  const {
    ref: ref1,
    isVisible: vis1
  } = useScrollAnimation();
  const {
    ref: ref2,
    isVisible: vis2
  } = useScrollAnimation();
  return <section id="preise" className="py-24 bg-gray-50" data-id="element-195">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-196">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-197">
          <span className="text-peony-600 font-semibold tracking-wider uppercase text-sm" data-id="element-198">
            Transparente Preise
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-dark-studio mt-2 mb-4" data-id="element-199">
            Unsere Angebote
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-200">
            Wähle das Paket, das am besten zu deinem Lifestyle passt – flexibel,
            fair und ohne versteckte Kosten.
          </p>
        </div>

        {/* Memberships */}
        <div className="mb-6" data-id="element-201">
          <h3 className="text-lg font-semibold text-gray-400 uppercase tracking-widest text-center mb-8" data-id="element-202">
            Mitgliedschaften
          </h3>
          <div ref={ref1} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ${vis1 ? '' : 'opacity-0'}`} data-id="element-203">
            {memberships.map((card, i) => <Card key={card.title} card={card} delay={i * 100} data-id="element-204" />)}
          </div>
        </div>

        {/* Divider */}
        <div className="flex items-center gap-4 my-12" data-id="element-205">
          <div className="flex-1 h-px bg-peony-100" data-id="element-206"></div>
          <span className="text-peony-400 font-medium text-sm uppercase tracking-widest" data-id="element-207">
            Einzeloptionen
          </span>
          <div className="flex-1 h-px bg-peony-100" data-id="element-208"></div>
        </div>

        {/* Singles */}
        <div ref={ref2} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ${vis2 ? '' : 'opacity-0'}`} data-id="element-209">
          {singles.map((card, i) => <Card key={card.title} card={card} delay={i * 100} data-id="element-210" />)}
        </div>
      </div>
    </section>;
}